import React, { useMemo } from "react";
import {
  DeviceSecurityProvider as SharedDeviceSecurityProvider,
  type DeviceSecurityRuntime,
} from "@orb-labs/orby-react";

/**
 * Web implementation of DeviceSecurityRuntime — a no-op that always reports
 * the device as secure. Browsers don't expose jailbreak/hook/debug signals
 * the way jail-monkey does on native, so there's nothing to check. Shared
 * screens that gate on device security (e.g. AuthBottomSheet's wallet
 * import flow) simply skip the check on mobile-web.
 */
export function WebDeviceSecurityProvider({ children }: { children: React.ReactNode }) {
  const runtime = useMemo<DeviceSecurityRuntime>(
    () => ({
      hasIssue: () => false,
      hasCriticalIssue: () => false,
      isSecure: () => true,
    }),
    []
  );
  return <SharedDeviceSecurityProvider runtime={runtime}>{children}</SharedDeviceSecurityProvider>;
}
